import React from 'react';

function ActionTab({ icon, label, mobileLabel, active, onClick, disabled }) {
  return (
    <button
      type='button'
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={[
        'flex flex-col sm:flex-row items-center justify-center gap-xs sm:gap-s py-xs sm:py-0 px-m flex-1',
        'body1 text-primary-dark',
        'border-0 border-r last:border-r-0 border-solid border-grey',
        active ? 'bg-primary-light border-b-2 border-b-primary-dark' : 'bg-white',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {icon && <span className='flex items-center sm:order-last'>{icon}</span>}
      {mobileLabel ? (
        <>
          <span className='hidden sm:inline'>{label}</span>
          <span className='sm:hidden'>{mobileLabel}</span>
        </>
      ) : (
        <span>{label}</span>
      )}
    </button>
  );
}

export default ActionTab;
